import { Eye, Lock } from "lucide-react";
import type React from "react";
import { useTranslation } from "react-i18next";
import { SelectionCard } from "@/components/common/SelectionCard";
import { Button } from "@/components/ui/button";
import {
  EVENT_TYPE_LOUNGE_WIDE,
  EVENT_TYPE_STUDYGROUP_ONLY,
  STUDYGROUP_VISIBILITY_SEARCH_DISABLED,
} from "@/constants";
import type { EventFormData } from "@/features/study-group-events/type";
import type { StudyGroupResponse } from "@/lib/humhub-api/types";

interface StepIsPublicProps {
  formData: EventFormData;
  onSelect: (
    value: typeof EVENT_TYPE_STUDYGROUP_ONLY | typeof EVENT_TYPE_LOUNGE_WIDE,
  ) => void;
  handleNext: () => void;
  isSubmitting: boolean;
  studyGroupInfo?: StudyGroupResponse | null;
}

export const StepIsPublic: React.FC<StepIsPublicProps> = ({
  formData,
  onSelect,
  handleNext,
  isSubmitting,
  studyGroupInfo,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-6 p-6">
      {/* ヘッダー */}
      <h1 className="text-xl font-semibold text-rw-black">
        {t("eventCreate.title")}
      </h1>

      {/* 選択カード */}
      <div className="grid grid-cols-2 gap-6 text-rw-black-gray">
        <SelectionCard
          label={t("eventManage.studyGroupOnly")}
          description={t("eventManage.studyGroupOnlyVisible")}
          IconComponent={Lock}
          isSelected={formData.is_public === EVENT_TYPE_STUDYGROUP_ONLY}
          onClick={() => onSelect(EVENT_TYPE_STUDYGROUP_ONLY)}
        />
        <SelectionCard
          label={t("eventManage.loungeWide")}
          description={t("eventManage.loungeWideVisibility")}
          IconComponent={Eye}
          isSelected={formData.is_public === EVENT_TYPE_LOUNGE_WIDE}
          disabled={
            studyGroupInfo?.visibility === STUDYGROUP_VISIBILITY_SEARCH_DISABLED
          }
          onClick={() => onSelect(EVENT_TYPE_LOUNGE_WIDE)}
          disabledMessage={
            studyGroupInfo?.visibility === STUDYGROUP_VISIBILITY_SEARCH_DISABLED
              ? t("eventManage.loungeWideNotAvailable")
              : undefined
          }
        />
      </div>

      <div className="flex justify-end">
        <Button
          onClick={handleNext}
          disabled={isSubmitting || formData.is_public === undefined}
          size="sm"
          variant="rw-sub"
          shaped
        >
          {t("common.next")}
        </Button>
      </div>
    </div>
  );
};
